import { useParams, Navigate, Link, useLocation } from "react-router-dom";
import { Seo } from "@/components/site/primitives";
import { LEGAL, LEGAL_INDEX } from "@/data/legal";

export default function LegalPage() {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const doc = LEGAL[slug];
  if (!doc) return <Navigate to="/legal/terms" replace />;

  return (
    <div data-testid="legal-page" className="bg-bone text-ink">
      <Seo title={doc.title} description={`${doc.title} — DataFrontier Innovations Private Limited.`} />
      <header className="border-b border-ink/10">
        <div className="mx-auto max-w-[1200px] px-5 pb-12 pt-32 md:px-8 md:pb-16 md:pt-44">
          <span className="eyebrow">Legal</span>
          <h1 className="mt-6 font-serif text-4xl tracking-tighter text-ink md:text-6xl">{doc.title}</h1>
          <div className="mt-6 font-mono text-xs text-ink/50">Last updated {doc.updated}</div>
        </div>
      </header>

      <div className="mx-auto grid max-w-[1200px] gap-12 px-5 py-16 md:px-8 md:py-20 lg:grid-cols-12">
        <aside className="lg:col-span-3">
          <div className="lg:sticky lg:top-28">
            <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-ink/50">Documents</div>
            <nav className="mt-4 space-y-1">
              {LEGAL_INDEX.map((l) => {
                const active = pathname === `/legal/${l.slug}`;
                return (
                  <Link
                    key={l.slug}
                    to={`/legal/${l.slug}`}
                    className={`block py-1.5 text-sm transition-colors duration-200 ${
                      active ? "text-saffron" : "text-ink/60 hover:text-ink"
                    }`}
                  >
                    {l.title}
                  </Link>
                );
              })}
            </nav>
          </div>
        </aside>

        <article className="max-w-measure lg:col-span-9">
          <p className="font-serif text-xl leading-[1.6] text-ink/80">{doc.intro}</p>
          {doc.sections.map((s) => (
            <section key={s.h} className="mt-12">
              <h2 className="font-serif text-2xl tracking-tight text-ink">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="mt-4 text-[16px] leading-[1.7] text-ink/75">
                  {para}
                </p>
              ))}
            </section>
          ))}
          <div className="mt-16 border-t border-ink/10 pt-8 font-mono text-xs text-ink/50">
            DataFrontier Innovations Private Limited · CIN U62091KA2024PTC184641 · Bengaluru, India
          </div>
        </article>
      </div>
    </div>
  );
}
